module.exports = __webpack_public_path__ + "static/slice-d50ec414581d540db969a05e8dc146bf.mp4";